import { permPlacementDetailsStore } from '@/app/features/perm-placements/features/perm-placement-details/perm-placement-details.store';
import { permPlacementsListingStore } from '@/app/features/perm-placements/features/perm-placements-listing/perm-placements-listing.store';
import { newPermPlacementStore } from '@/app/features/perm-placements/features/new-perm-placement/new-perm-placement.store';
export const permPlacementsStore = {
  modules: {
    permPlacementDetailsState: permPlacementDetailsStore,
    permPlacementsListingState: permPlacementsListingStore,
    newPermPlacementState: newPermPlacementStore
  }
};
